import {palette} from '@/styles';
import {AreaOverlayType} from '../enums';

export const SHAPE_COLOR_OPTIONS = {
  [AreaOverlayType.CIRCLE]: {
    fillColor: '#F17F1F',
    strokeColor: '#F17F1F',
    fillOpacity: 0.1,
    strokeWeight: 2,
  },
  [AreaOverlayType.POLYGON]: {
    fillColor: palette.blue400,
    strokeColor: palette.blue400,
    fillOpacity: 0.1,
    strokeWeight: 2,
  },
  [AreaOverlayType.EMD]: {
    fillColor: palette.blue400,
    strokeColor: palette.blue400,
    fillOpacity: 0.1,
    strokeWeight: 2,
  },
};

export const RADIUS_OPTIONS: Array<number | 'reset'> = [
  100,
  300,
  500,
  1000,
  1500,
  2000,
  3000,
  'reset',
];
